export const exclusive = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber',
    'Patented Multi-functional Mounting Base & Adapters',
    'Giant Vents Make the Air Flow Smoothly',
  ],
  'material': [
    'Rubber: Premium Nature Rubber',
    'Steel: SGCC, Electrostatic Powder Coating',
    'Rivet: SUS302ES',
    'Plastic (Spacer & Adapter): POM ',
    'Stainless Steel Backing: SUS304ES',
  ],
  'featureIcons': ["11", "02", "03", "06"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "12", "mm": "300", "claw": "4", "width": "6", "thickness": "1.2" },
    { "inch": "13", "mm": "325", "claw": "4", "width": "6", "thickness": "1.2" },
    { "inch": "14", "mm": "350", "claw": "4", "width": "6", "thickness": "1.2" },
    { "inch": "15", "mm": "375", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "16", "mm": "400", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "17", "mm": "425", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "18", "mm": "450", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "19", "mm": "475", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "20", "mm": "500", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "21", "mm": "530", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "22", "mm": "560", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "23", "mm": "580", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "24", "mm": "600", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "1.2" }
  ],
  'adapters': ["b1", "b6", "bl-2a", "cl+cl-r", "m3", "m4", "m5", "ml", "ph-3", "pl", "pt-3", "pt6", "pt-r", "tl-2", "tl4a", "tlc", "a3"]
}
